import LayoutBasic from '../layouts/layoutBasic'
import { withRouter } from 'next/router'
import axios from 'axios'
import {TOKEN, GET_WALLPAPERS_PHOTOS, DOWNLOAD_WALLPAPER, GET_USER_URL} from '../vars'
import {GET} from '../helpers'
import {getLocalKeyValue, setSessionKeyValue} from '../storage'
import FileDownload from '../components/filedownload'
import DownloadButton from '../components/downloadButton'
import Pagination, {SimplePager} from '../components/pagination'
import ProgressiveImage from 'react-progressive-image'
import LazyLoad from 'react-lazyload';

class Wallpapers extends React.Component {

  static async getInitialProps(props) {

    let token = process.browser ? getLocalKeyValue(TOKEN) : props.query.sec_token

    let infoRequest, infoResponse={}
    if(token) {
      try {
        infoRequest = await GET(GET_USER_URL, token)
        infoResponse = await infoRequest.data
      } catch (e) {

      }
    }

    try {
      const res = await GET(GET_WALLPAPERS_PHOTOS+'?page='+(props.query.page ? props.query.page:1))
      const data = await res.data

      return {
        cart: infoResponse.cart,
        token: token,
        user: infoResponse.user,
        photos: data.results,
        total_pages:data.total_pages,
        next_page: data.next_page,
        previous_page:data.previous_page,
        current_page:data.page,
        total_pages: data.total_pages,
        pagination: {
          page: data.page,
          total_pages: data.total_pages
        }
      }
    } catch (e) {
      return {
        cart: infoResponse.cart,
        token: token,
        user: infoResponse.user,
      }
    }
  }

  render () {
    let props = this.props
    let browser_title = "Picxy Wallpapers " + (props.current_page> 1 ? "page " +props.current_page: "")
    let photos
    if (props.photos) {
      photos = props.photos.map((photo,id) =>{
        let photo_src = photo.thumbnail_img
        let content = <LazyLoad key={photo.id} once>
            <div className="wallpaper-content text-center">
              <ProgressiveImage src={photo_src} key={photo.id} placeholder="../../static/img/favicon.png">
                {src=><img className="img-fluid rounded-lg" src={photo_src} />}
              </ProgressiveImage>
              <div className="text-center wallpaper-download">
                <DownloadButton wallpaper={photo} />
              </div>
            </div>
          </LazyLoad>
        let className = "col-md-3 col-sm-6 mb-4"
        return <div className= {className}>
              {content}
        </div>
      })
    }
    else{
      photos = <div className="col text-center">No photos found!</div>
    }

    let pagination
    if(props.total_pages > 1 ) {
      pagination = <SimplePager {...this.props} />
    }

    return <LayoutBasic title={browser_title} {...props} defaultNavBar={true}>
      <div className="container font-small my-5">
        <div className="text-center mb-5">
          <h1 className="mb-3">Picxy Wallpapers</h1>
        </div>
        <div className="row justify-content-center">
          {photos}
        </div>

        <div className="row ">
            <div className="col text-sm-end">
              {pagination}
            </div>
        </div>
      </div>
    </LayoutBasic>
  }
}

export default withRouter(Wallpapers)
